import styles from "../../screens/ThirdScreen.module.css";
import { useEffect, useRef } from "react";
import { Player } from "@lordicon/react";
import ScrollReveal from "scrollreveal";
import trophy from "../../icons/wired-outline-1018-signature-sig-hover-pinch.json";
import growth from "../../icons/wired-outline-1027-marketing-campaign-hover-jump (1).json";
import target from "../../icons/wired-outline-2610-lead-generation-hover-pinch.json";
import community from "../../icons/wired-outline-2342-hugging-love-hover-pinch.json";
import rocket from "../../icons/wired-outline-152-bar-chart-arrow-hover-growth (1).json";
import Button from "../../components/button/Button";

const WhatHappens = () => {
  const playerRef1 = useRef();
  const playerRef2 = useRef();
  const playerRef3 = useRef();
  const playerRef4 = useRef();
  const playerRef5 = useRef();

  useEffect(() => {
    ScrollReveal().reveal(`.${styles.title}`, {
      duration: 1000,
      distance: "30px",
      origin: "top",
      easing: "ease-out",
      reset: false,
      viewFactor: 0.2,
      interval: 300,
      delay: 200,
      scale: 1,
    });
    ScrollReveal().reveal(`.${styles.section}`, {
      duration: 1000,
      distance: "30px",
      origin: "right",
      easing: "ease-in-out",
      reset: false,
      viewFactor: 0.2,
      interval: 300,
      delay: 200,
      scale: 1,
    });
    ScrollReveal().reveal(`.${styles.stepHeader}`, {
      duration: 1000,
      distance: "30px",
      origin: "top",
      easing: "ease-in-out",
      reset: false,
      viewFactor: 0.2,
      interval: 300,
      delay: 200,
      scale: 1,
    });

    playerRef1.current?.playFromBeginning();
    playerRef2.current?.playFromBeginning();
    playerRef3.current?.playFromBeginning();
    playerRef4.current?.playFromBeginning();
    playerRef5.current?.playFromBeginning();
  }, []);

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.titleContainer}>
          <h2 className={styles.title}>
            <span className={styles.titleWhite}>אז מה יקרה לעסק שלך ברגע </span>
            <span className={styles.titleHighlight}>שתהפכי למותג ברשתות</span>
          </h2>
        </div>

        <div className={styles.bigWrapper}>
          <div className={styles.step} itemScope itemType="https://schema.org/Thing">
            <div className={styles.icons}>
              <Player
                ref={playerRef1}
                size="100%"
                onComplete={() => playerRef1.current?.playFromBeginning()}
                icon={trophy}
              />
            </div>
            <div className={styles.text}>
              <div className={styles.stepHeader} itemProp="name">
                תבני מוניטין של אוטוריטה
              </div>
              <div className={styles.section} itemProp="description">
                התוכן שלך הולך לשדר שאת המקצוענית הכי גדולה שיש. עם תוכן מדוייק איכותי ועקבי, המותג שלך יפסיק להיראות "נחמד" ויתחיל להיראות מוביל. לקוחות פוטנציאליים יזהו מיד את הסמכות והדיוק שלך, מה שייצור אמון עמוק ויגרום להן לבחור בך בלי להסס ובלי להשוות אותך לאף אחת אחרת.
              </div>
            </div>
          </div>

          <div className={styles.step} itemScope itemType="https://schema.org/Thing">
            <div className={styles.text}>
              <div className={styles.stepHeader} itemProp="name">
                נתוני החשיפה שלך יזנקו – והלקוחות הנכונים יגיעו
              </div>
              <div className={styles.section} itemProp="description">
                במקום שאת תרדפי אחרי האלגוריתם, אנחנו נגרום לו לעבוד בשבילך. ברגע שהתוכן שלך יהיה מדויק, עקבי ואיכותי, החשיפה שלך תתרחב בדיוק לאנשים שחיכית להם. את לא רק תקבלי "לייקים", את תבני סביבך קהילה של אנשים שמעריכים את הידע שלך, עוקבים ומחכים בציפייה לפרסום הבא שלך.
              </div>
            </div>
            <div className={styles.icons}>
              <Player
                ref={playerRef2}
                delay={500}
                size="100%"
                onComplete={() => playerRef2.current?.playFromBeginning()}
                icon={growth}
              />
            </div>
          </div>

          <div className={styles.step} itemScope itemType="https://schema.org/Thing">
            <div className={styles.icons}>
              <Player
                ref={playerRef3}
                size="100%"
                onComplete={() => playerRef3.current?.playFromBeginning()}
                icon={target}
              />
            </div>
            <div className={styles.text}>
              <div className={styles.stepHeader} itemProp="name">
                הלידים שלך יהיו רותחים והפניות ממוקדות
              </div>
              <div className={styles.section} itemProp="description">
                ברגע שהעמוד שלך מעביר מסע מכירה חכם, הלקוחות מגיעים אלייך כשהם כבר "מבושלים". תוכן מדויק ורלוונטי ימשוך אלייך רק את הלקוחות הנכונים, אלו שמעריכות את המקצוענות שלך ומוכנות לשלם עליה. במקום לרדוף אחרי כולם, את תתחילי לקבל פניות ממוקדות מאנשים שכבר מכירים אותך, סומכים עלייך ורוצים רק אותך.
              </div>
            </div>
          </div>

          <div className={styles.step} itemScope itemType="https://schema.org/Thing">
            <div className={styles.text}>
              <div className={styles.stepHeader} itemProp="name">
                הלקוחות שלך יכירו אותך
              </div>
              <div className={styles.section} itemProp="description">
                בעידן של היום, אנשים קונים מאנשים, אבל זה לא אומר שאת צריכה להפוך ל"ליצנית החצר" או לחשוף את כל החיים האישיים שלך. נוכחות מדויקת ואותנטית תאפשר ללקוחות שלך להתחבר לערכים ולמקצוענות שלך, בלי שתצטרכי להרגיש חשיפת יתר. אנחנו ניצור עבורך קשרים אמיתיים מבוססי אמון, שבהם הלקוחות יבינו שאת הכתובת המדויקת לבעיה שלהן ויעריכו את מי שאת.
              </div>
            </div>
            <div className={styles.icons}>
              <Player
                ref={playerRef4}
                delay={500}
                size="100%"
                onComplete={() => playerRef4.current?.playFromBeginning()}
                icon={community}
              />
            </div>
          </div>

          <div className={styles.step} itemScope itemType="https://schema.org/Thing">
            <div className={styles.icons}>
              <Player
                ref={playerRef5}
                size="100%"
                onComplete={() => playerRef5.current?.playFromBeginning()}
                icon={rocket}
              />
            </div>
            <div className={styles.text}>
              <div className={styles.stepHeader} itemProp="name">
                תחווי צמיחה עסקית מתמשכת ותממשי את הפוטנציאל שלך
              </div>
              <div className={styles.section} itemProp="description">
                נוכחות חזקה ברשת היא לא רק "שיווק", היא מנוע הצמיחה שחיכית לו כדי להפסיק להסתפק ב"בסדר" ולהתחיל להוביל. ברגע שהמסרים שלך מדויקים והתוכן שלך עובד בשבילך, את מפסיקה לדרוך במקום ומתחילה לפרוץ קדימה. כל פוסט וכל סטורי הופכים להזדמנות עסקית אמיתית, לשיתופי פעולה וללקוחות חדשים שרוצים בדיוק את מה שיש לך להציע.
              </div>
            </div>
          </div>
        </div>

        <Button text="בואי נעלה את העסק שלך רמה!" />
      </div>
    </div>
  );
};

export default WhatHappens;
